import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import type { TimeFormatPreference } from './timeFormat';

const isValidTimeFormat = (value: unknown): value is '12h' | '24h' => {
    return typeof value === 'string' && (value === '12h' || value === '24h');
};

const isValidPreferences = (preferences: unknown): preferences is { timeFormat: '12h' | '24h' } => {
    if (!preferences || typeof preferences !== 'object' || preferences === null) return false;
    if (!('timeFormat' in preferences)) return false;
    return isValidTimeFormat(preferences.timeFormat);
};

export const getUserTimeFormatPreference = async (): Promise<TimeFormatPreference> => {
    const defaultPreference: TimeFormatPreference = { timeFormat: '24h' };

    try {
        const preferences = await fetchFromLambda('/organisation/page-preferences/me/global');
        return isValidPreferences(preferences) ? preferences : defaultPreference;
    } catch {
        // Failed to fetch user time format preference
        return defaultPreference;
    }
};